import styled from 'styled-components';

import { TEXT_GRAY, WHITE, BLACK } from '../../../../styles/variables.style';
import media from '../../../../styles/media.style';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const RecipeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  ${media.tabletP`
    flex-direction: row;
  `};
`;

export const RecipeTitle = styled.h4`
  color: ${TEXT_GRAY.COMMON_3};
  text-transform: uppercase;
  margin-top: 0;
`;

export const LeftList = styled.div`
  flex: 1;
`;

export const DeveloperInfo = styled.div`
  flex: 3;
`;

export const ServicesList = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;

  li {
    margin-bottom: 15px;
    margin-right: 20px;
  }

  ${media.tabletP`
    display: block;

    li {
      margin-right: 0;
    }
  `};
`;

export const CheckboxBtn = styled.button`
  position: relative;
  background-color: transparent;
  border: none;
  text-align: left;
  margin: 0;
  padding: 0;
  color: ${WHITE};
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  font-size: 14px;
  font-weight: 400;
  padding-left: 35px;
  line-height: 25px;
`;

export const Checkbox = styled.div`
  position: absolute;
  top: 50%;
  left: 5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid ${WHITE};
  background-color: transparent;
  transform: translateY(-50%);

  ::after {
    content: '';
    opacity: ${({ checked }) => (checked ? '1' : '0')};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${WHITE};
    width: 6px;
    height: 6px;
    transition: opacity 0.3s;
    border-radius: 50%;
  }
`;

export const DeveloperSelectWrapper = styled.div`
  position: relative;
  display: inline-block;
  background-color: transparent;
  border: 1px solid ${WHITE};
  height: 55px;
  padding: 0;
  line-height: 55px;
  color: ${WHITE};
  width: calc(50% - 3.5px);
  text-align: left;
  margin: 0 7px 12px 0;
  vertical-align: top;

  select {
    width: 100%;
    appearance: none;
    background: transparent;
    font-size: 16px;
    font-weight: 600;
    height: 55px;
    line-height: 55px;
    border: none;
    color: ${WHITE};
    padding-left: 25px;
    letter-spacing: 1px;
    vertical-align: top;

    ::-ms-expand {
      display: none;
    }
  }

  ::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%) rotate(135deg);
    transform-origin: 6px 4px;
    width: 8px;
    height: 8px;
    border-top: 1px solid ${WHITE};
    border-right: 1px solid ${WHITE};
    transition: transform 0.3s;
  }
`;

export const RecipesList = styled.ul``;

export const RangeSelectWrapper = DeveloperSelectWrapper.extend`
  margin: 0;
`;
export const RatioSelectWrapper = DeveloperSelectWrapper.extend`
  margin: 0 0 20px;
  width: 100%;

  ${media.tabletP`
    width: calc(50% - 3.5px);
    margin: 0;
  `};
`;
export const ProductNameWrapper = styled.div`
  position: relative;
  display: inline-block;
  background-color: transparent;
  border: 1px solid ${WHITE};
  padding: 0;
  width: 100%;
  margin: 0 7px 12px 0;
  height: 55px;

  input {
    height: 55px;
    line-height: 55px;
    color: ${WHITE};
    letter-spacing: 1px;
    font-size: 16px;
    padding: 0 25px;
    background-color: transparent;
    width: 100%;
    border: none;
  }

  ${media.tabletP`
    width: calc(50% - 3.5px);
  `};
`;

export const RatioNameWrapper = ProductNameWrapper.extend`
  margin: 0 0 20px;
  width: 100%;

  ${media.tabletP`
    width: calc(50% - 3.5px);
    margin: 0;
  `};
`;

export const Footer = styled.div`
  display: flex;

  ${media.tabletP`
    justify-content: flex-end;
  `};
`;
export const CancelBtn = styled.button`
  background-color: transparent;
  border: none;
  text-decoration: underline;
  text-transform: uppercase;
  cursor: pointer;
  font-weight: 800;
  font-size: 13px;
  margin-right: 20px;
  color: ${WHITE};
  margin-top: 10px;
`;
export const SaveBtn = styled.button`
  background-color: transparent;
  border: none;
  text-decoration: underline;
  text-transform: uppercase;
  cursor: pointer;
  font-weight: 800;
  font-size: 13px;
  color: ${WHITE};
  margin-top: 10px;

  :disabled {
    color: ${TEXT_GRAY.COMMON_5};
  }
`;
export const AddMoreBtn = styled.button`
  background-color: transparent;
  border: none;
  text-decoration: underline;
  text-transform: uppercase;
  cursor: pointer;
  font-weight: 800;
  font-size: 13px;
  color: ${WHITE};
  margin-top: 10px;
`;
export const CreateNewRecipeBtn = styled.button`
  background-color: transparent;
  border: none;
  text-decoration: underline;
  text-transform: uppercase;
  cursor: pointer;
  font-weight: 800;
  font-size: 13px;
  color: ${WHITE};
  align-self: flex-end;
  margin-top: 15px;
`;

export const SavedProductItem = styled.div`
  width: 100%;
  display: flex;
  border: 1px solid ${WHITE};
  padding: 0 22px 0 30px;
  height: 55px;
  margin-bottom: 7px;
`;
export const SavedProductName = styled.p`
  display: inline-block;
  flex: 2;
  line-height: 55px;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 10px;
`;
export const SavedProductRatio = styled.p`
  display: inline-block;
  flex: 1;
  line-height: 55px;
  margin: 0;
`;
export const DeleteBtn = styled.button`
  position: relative;
  border: none;
  background-color: transparent;
  margin-left: auto;
  cursor: pointer;
  padding: 0;
`;

export const CloseIcon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  right: 0;
  display: inline-block;
  width: 25px;
  height: 25px;
  color: ${BLACK};
  background-color: transparent;
  vertical-align: middle;
  line-height: 40px;
  padding-left: 12px;

  ::after {
    content: '';
    width: 20px;
    height: 2px;
    background-color: ${WHITE};
    position: absolute;
    top: 51%;
    left: 51%;
    transform: translate(-50%, -50%);
  }

  ::before {
    content: '';
    width: 20px;
    height: 2px;
    background-color: ${WHITE};
    position: absolute;
    top: 51%;
    left: 51%;
    transition: transform 0.3s;
    transform: translate(-50%, -50%) rotate(${({ open }) => (open ? 0 : '90deg')});
  }
`;

export const SavedProductColor = styled.div`
  background-color: ${({ color }) => color};
  flex: 0 53px;
  height: 100%;
  margin-left: -30px;
  margin-right: 22px;
`;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/NewVisitPage/Treatments/HairColor.style.js